import { Component, } from '@angular/core';
import { AlertController , NavController} from 'ionic-angular';
import {datos} from '../../providers/datos';
import { ToastController } from 'ionic-angular';
import { ModalController,NavParams } from 'ionic-angular';
import { Modal } from '../modal/modal';
import leaflet from 'leaflet'
import { Detalle } from '../detalle/detalle';
// import swal from 'sweetalert';

import { ViewChild, ElementRef } from '@angular/core';
;


declare var swal:any

@Component({
  templateUrl: 'lista.html',
  selector: 'lista',
  providers: []
})

export class lista {
  @ViewChild('map') mapContainer: ElementRef;
  map: any;
  pagina ={
  "title": "Servicios",
  "boton": "Pruébalo ahora !",
  "sub_titulo": "a la comodidad de su hogar",
   "background": "assets/images/app/fondo.jpg"}

  items=  [

            ];

  // services: array
  constructor(
    private datos:datos,
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private modalCtrl:ModalController,
    public navParams: NavParams,
    public navCtrl: NavController,
  ) {


    this.iniciar();
this.ultimaUbicacion();

    // setInterval(() => {
    //   // this.addMarket(this.datos.activo.lat,this.datos.activo.lng);
    // }, 1000);

  }




  // loadmap() {
  //   this.map = leaflet.map("map").fitWorld();
  //   leaflet.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //     attributions: 'www.tphangout.com',
  //     maxZoom: 18
  //   }).addTo(this.map);
  // }



  loadmap() {

    var greenIcon = new leaflet.Icon
    
    ({
      iconUrl: 'assets/images/coche.png',
     // shadowUrl: 'assets/images/coche.png',
      iconSize:     [56, 30], // size of the icon
      shadowSize:   [0, 0], // size of the shadow
      iconAnchor:   [0, 0], // point of the icon which will correspond to marker's location
      shadowAnchor: [4, 62],  // the same for the shadow
      popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
  })

  
    this.map = leaflet.map("map").fitWorld();
    leaflet.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attributions: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
      maxZoom: 20
    }).addTo(this.map);
    this.map.locate({
      setView: true,
      maxZoom: 17
    })
    // .on('locationfound', (e) => {
      // let markerGroup = leaflet.featureGroup();
      // let marker: any = leaflet.marker([e.latitude, e.longitude]).on('click', () => {
      //   // alert('Marker clicked');
      // })

    //   marker.setIcon(greenIcon); 

      
    //   markerGroup.addLayer(marker);
    //   this.map.addLayer(markerGroup);
    //   }).on('locationerror', (err) => {
    //     alert(err.message);
    // })
 
  }


  addMarket(lat,lng){
console.log("lat:"+lat);
console.log("lng:"+lng);

    var greenIcon = new leaflet.Icon
    
    ({
      iconUrl: 'assets/images/coche.png',
     // shadowUrl: 'assets/images/coche.png',
      iconSize:     [56, 30], // size of the icon
      shadowSize:   [0, 0], // size of the shadow
      iconAnchor:   [0, 0], // point of the icon which will correspond to marker's location
      shadowAnchor: [4, 62],  // the same for the shadow
      popupAnchor:  [-3, -76] // point from which the popup should open relative to the iconAnchor
  })



    let markerGroup = leaflet.featureGroup();
    let marker: any = leaflet.marker([lat, lng]).on('click', () => {
      // alert('Marker clicked');
    })

    marker.setIcon(greenIcon); 

      
      markerGroup.addLayer(marker);
      this.map.addLayer(markerGroup);
      



  }



  ultimaUbicacion(){

    let p ={id:this.datos.activo.id}
    this.datos.ultimaUbicacion(p).
    subscribe(
      data => {
      this.datos.activo.lat= data.data[0].latitud;
      this.datos.activo.lng= data.data[0].longitud;
    this.addMarket(this.datos.activo.lat,this.datos.activo.lng);

      console.log(data);


    })
    
    ; 
  }



  getMenu(lista){
    console.log(lista);
    for (let i= 0; i<lista.length; i++) {
      setTimeout(() => {
        this.items.push(lista[i]);
      }, 500*i);

    }
  }



 

  ionViewDidEnter() {
    this.loadmap();
  }



  iniciar()
  {

   let lista =  this.navParams.get('items');
   this.getMenu(lista);

   console.log(lista);


  }




}



// WEBPACK FOOTER //
// ./src/pages/lista/lista.ts